export const dataFaq = [
  {
    category: "Personal Information",
    items: [
      {
        title: "Update my name",
        content: (
          <div>
            <ul>
              <li>
                &bull; Click the three vertical dots next to your name and
                client code.
              </li>
              <li>&bull; Click ‘My Profile’</li>
              <ul className="pl-10">
                <li>
                  &bull; You will see your name, followed by a right pointing
                  arrow (&gt; ), click this arrow
                </li>
                <li>
                  &bull; You will then have the ability to update your name.
                </li>
              </ul>
              <li>Once you have updated your name, click save.</li>
              <li>
                You will receive a green confirmation message confirming that
                your name has been updated.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077546960/af8276645e" target="_blank">
                "Updating Your Name"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Update my phone number",
        content: (
          <div>
            <ul>
              <li>
                &bull; Click the three vertical dots next to your name and
                client code.
              </li>
              <li>&bull; Click ‘My Profile’</li>
              <ul className="pl-10">
                <li>
                  &bull; The top section of your profile shows your personal
                  details, and below there is a section for your contact info,
                  including your phone number
                </li>
              </ul>
              <li>
                &bull; To update your number, simply click the right arrow (&gt;
                ) next to your phone number
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You will be taken to the change phone number screen
                  where you can update your contact info, click save.
                </li>
              </ul>
              <li>
                &bull; You will receive a green confirmation message confirming
                that your number has been successfully updated.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077546994/cdb36bc424" target="_blank">
                "Updating Your Phone Number"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Update my password",
        content: (
          <div>
            <ul>
              <li>
                <strong>&bull; Logged out option</strong>
              </li>
              <ul className="pl-10">
                <li>
                  &bull; If you’re logged out of your account, you can change
                  your password by going to the FBTC login page and selecting
                  the ‘Forgot Password?’ option
                </li>
                <ul className="pl-10">
                  <li>
                    &bull; We will then ask you to enter the email address that
                    you normally use to login to your account
                  </li>
                  <li>
                    &bull; A password reset link will then be emailed to this
                    address
                  </li>
                </ul>
                <li>
                  &bull; Clicking the link in this email will open a new page
                  where you can enter your new password and confirm it
                </li>
                <li>
                  &bull; Once you have saved your new password, you can use it
                  to login with your email address as normal
                </li>
              </ul>
              <li>
                <strong>&bull; Logged in option</strong>
              </li>
              <ul className="pl-10">
                <li>
                  &bull; If you’re logged into your account, you can change your
                  password through ‘My profile’
                </li>
                <li>
                  &bull; Click the three vertical dots next to your name and
                  client code.
                </li>
                <li>&bull; Click ‘My Profile’</li>
                <ul className="pl-10">
                  <li>
                    &bull; In personal details, you will see the password
                    section, click the right hand arrow (&gt; )
                  </li>
                  <li>
                    &bull; Here, you can update your password by entering your
                    current password, the new password you wish to use, and
                    confirming that password, and hitting the ‘Change Password’
                    button to save it.
                  </li>
                </ul>
                <li>
                  &bull; You can then log in with your new password going
                  forward.
                </li>
              </ul>
            </ul>
          </div>
        ),
      },
      {
        title: "Update my email address",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you wish to update the email address we use to login
                to your account, and that we use to contact you, then you will
                need to reach out to the FBTC team.
              </li>
              <li>
                &bull; You can do this by using our Request a Call feature, by
                emailing us at info@fbtc.co.uk, or calling us on 0344 984 2515.
              </li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "Businesses",
    items: [
      {
        title: "Add a business",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you wish to add another business to your account, then
                you will need to reach out to the FBTC team.
              </li>
              <li>
                &bull; You can do this by using our Request a Call feature, by
                emailing us at info@fbtc.co.uk, or calling us on 0344 984 2515.
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Delete a business",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you wish to delete a business from your account, then
                you will need to reach out to the FBTC team.
              </li>
              <li>
                &bull; You can do this by using our Request a Call feature, by
                emailing us at info@fbtc.co.uk, or calling us on 0344 984 2515.
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "View information and add records for my various businesses",
        content: (
          <div>
            <ul>
              <li>
                &bull; We ask our clients to select a default business on their
                account
              </li>
              <li>
                &bull; A default business is usually the business that you
                conduct the majority of your work through.
              </li>
              <ul className="pl-10">
                <li>
                  &bull; Setting a default business means that when you view
                  your dashboard, or add or view transactions, submissions, or
                  assets, that we will default to showing you records for that
                  business.
                </li>
              </ul>
              <li>
                &bull; You can change which business you are looking at or
                updating records for at any time, by using the business drop
                down and selecting one of your other businesses.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547056/e94208b6b9" target="_blank">
                "Viewing Business Information"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "View My Businesses",
        content: (
          <div>
            <ul>
              <li>
                &bull; Click the three vertical dots next to your name and
                client code.
              </li>
              <li>&bull; Click ‘My Profile’</li>
              <ul className="pl-10">
                <li>
                  &bull; The top section of your profile shows your personal
                  details, and underneath this you can view ‘My Businesses’
                </li>
              </ul>
              <li>
                &bull; This section allows you to view all of the businesses
                associated with your account
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Set a default business",
        content: (
          <div>
            <ul>
              <li>
                &bull; Click the three vertical dots next to your name and
                client code.
              </li>
              <li>&bull; Click ‘My Profile’</li>
              <ul className="pl-10">
                <li>
                  &bull; The top section of your profile shows your personal
                  details, and underneath this you can view ‘My Businesses’
                </li>
              </ul>
              <li>
                &bull; This section allows you to view all of the businesses
                associated with your account
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You can also see which business is marked as your
                  ‘Default Business’ and update this here if you want to.
                </li>
              </ul>
              <li>
                &bull; To change a Business to be a default, you simply need to
                click ‘Mark as Default’ above the Business you want to be
                default.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547041/24697791ae" target="_blank">
                "Set a Default Business"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Queries",
    items: [
      {
        title: "What is a query? ",
        content: (
          <div>
            <p>
              A query is a question sent by your accountant about an aspect of
              one of your submissions, or tax return. They might, for example,
              ask you to attach a missing receipt for an expense, or double
              check an amount on a transaction that looks too high or low.
            </p>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1235818112/66782e119c" target="_blank">
                "How to use queries"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "What is the benefit of the query system?",
        content: (
          <div>
            <p>
              Having a query system within the FBTC web portal and mobile
              application allows fast communication and resolution of issues
              between your accountant and yourself, while reviewing your
              submission or preparing your tax return.
            </p>
          </div>
        ),
      },
      {
        title: "Where can I find my queries?",
        content: (
          <div>
            <p>
              There will be a new tab on the navigation menu called ‘Queries’.
              If you have an unresolved query, then a number will appear next to
              this tab to highlight it to you. When an accountant sends you a
              query, you will receive a notification, and at the end of the day,
              you will receive an email summarising any queries you’ve received
              that require action.
            </p>
          </div>
        ),
      },
      {
        title: "How do I know what to do with a query?",
        content: (
          <div>
            <p>
              When your accountant sends you a query, it will be highlighted as
              ‘Action Required’. All you need to do is read the query, take the
              appropriate action, and send a message to your accountant to
              confirm it has been done. When you reply to a query, it will go
              into the status ‘Awaiting FBTC’ and your accountant will be
              notified of your response. They can then either ask for further
              information or resolve the query. Once a query has been resolved,
              it will appear in the ‘Resolved’ query section.
            </p>
          </div>
        ),
      },
      {
        title: "How can I get Help using queries?",
        content: (
          <div>
            <p>
              On the Queries page there is a blue Help? button next to the page
              title. If you click this button, you can watch tutorials, read
              FAQs, or view a demonstration video on using Queries.
            </p>
          </div>
        ),
      },
      {
        title: "How do I find my queries?",
        content: (
          <div>
            <ul>
              <li>&bull; Login to platform</li>
              <li>&bull; Select Queries from the main navigation bar</li>
              <li>
                &bull; Switch between <strong>Submission queries</strong> — tied
                to a specific business and period — and{" "}
                <strong>Tax return queries</strong> — about your overall tax
                return
              </li>
              <li>
                &bull; On Submission queries, select the business you want to
                see queries for, then pick a period
              </li>
              <li>&bull; On Tax return queries, pick a tax year</li>
            </ul>
          </div>
        ),
      },
      {
        title: "What do the different query statuses mean?",
        content: (
          <div>
            <ul>
              <li>
                &bull; <strong>Action Required</strong> — FBTC needs an answer
                or document from you
              </li>
              <li>
                &bull; <strong>Awaiting FBTC</strong> — you've replied and FBTC
                is reviewing it
              </li>
              <li>
                &bull; <strong>Resolved</strong> — the query is closed, no
                further action needed
              </li>
              <li>
                &bull; The red number next to a business or tab shows how many
                of your queries currently need a response
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "How do I reply to a query?",
        content: (
          <div>
            <ul>
              <li>
                &bull; Click into a query to see the full conversation with FBTC
              </li>
              <li>
                &bull; Type your response in the message box at the bottom
              </li>
              <li>
                &bull; Click send — FBTC will be notified and the query status
                changes to Awaiting FBTC
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Can I raise a new query myself?",
        content: (
          <div>
            <ul>
              <li>
                &bull; Queries are raised by FBTC when they need more
                information from you — for example a missing receipt or an
                unclear transaction
              </li>
              <li>
                &bull; You can't start a new query yourself, but you can reply
                to any that are open
              </li>
              <li>
                &bull; If you have something to ask that isn't tied to an
                existing query, use Report a Problem or Request a Call (see the
                Contact section)
              </li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "Assets Guide",
    videoLink: "https://vimeo.com/1100639491",
    items: [
      {
        title: "What is an asset?",
        content: (
          <div>
            <p>
              An asset is a valuable item your business owns or uses to generate
              income or support operations. Examples include:
            </p>
            <ul className="pl-10">
              <li>&bull; A car used by a driving instructor</li>
              <li>&bull; Tools used by a tradesperson</li>
            </ul>
            <p>
              Recommendation: Record items as assets if their value exceeds
              £300. Lower-value items should be recorded as expenses (e.g.,
              Motor - Service/Repairs, Repairs and Maintenance, Computer Costs).
            </p>
          </div>
        ),
      },
      {
        title: "How to add an asset",
        content: (
          <div>
            <ul>
              <li>&bull; Choose your business and asset type</li>
              <li>&bull; Complete the asset form with relevant details</li>
              <li>&bull; Upload supporting documents</li>
              <li>&bull; Save the asset to your account</li>
            </ul>
          </div>
        ),
      },
      {
        title: "Why add an asset?",
        content: (
          <div>
            <p>Adding assets to FBTC ensures:</p>
            <ul className="pl-10">
              <li>&bull; Accurate tracking of costs and related expenses</li>
              <li>&bull; Improved financial reporting</li>
              <li>&bull; Smoother tax preparation and accounting processes</li>
            </ul>
          </div>
        ),
      },
      {
        title: "Asset types and how to add them",
        content: (
          <div>
            <ul>
              <li>
                <strong>1. Vehicle Asset (e.g., cars, buses, trucks)</strong>
              </li>
              <ul className="pl-10">
                <li>&bull; Select Business Type</li>
                <li>&bull; Choose Asset Type: Vehicle</li>
                <li>&bull; Enter Vehicle Registration Number (asset name)</li>
                <li>
                  &bull; Choose Purchase Type: Outright, Hire Purchase (HP),
                  Personal Contract Purchase (PCP), Loan, Lease
                </li>
                <li>
                  &bull; Enter Purchase/Lease Date and Cost (if not leased)
                </li>
                <li>&bull; Add comments (optional)</li>
                <li>&bull; Upload documents</li>
                <li>&bull; Save asset</li>
              </ul>
              <li>
                <strong>2. Rental Property Asset</strong>
              </li>
              <ul className="pl-10">
                <li>&bull; Select Business Type: Landlord</li>
                <li>&bull; Choose Asset Type: Rental Property</li>
                <li>&bull; Enter Property Address (asset name)</li>
                <li>
                  &bull; Choose Purchase Type: Outright, Mortgage, Lease, Loan
                </li>
                <li>&bull; Enter Purchase/Lease Date</li>
                <li>
                  &bull; Enter Joint Ownership and percentage if applicable
                </li>
                <li>&bull; Enter Cost (if not leased)</li>
                <li>&bull; Upload documents</li>
                <li>&bull; Save asset</li>
              </ul>
              <li>
                <strong>
                  3. Other Asset (e.g., equipment, tools, computers)
                </strong>
              </li>
              <ul className="pl-10">
                <li>&bull; Select Business Type</li>
                <li>&bull; Choose Asset Type: Other</li>
                <li>&bull; Describe Asset (asset name)</li>
                <li>&bull; Choose Purchase Type: Outright, Finance</li>
                <li>&bull; Enter Purchase Date and Cost</li>
                <li>&bull; Upload documents</li>
                <li>&bull; Save asset</li>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1100639491" target="_blank">
                "Adding a vehicle Asset"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Handling missing documents",
        content: (
          <div>
            <p>If documents aren’t available during upload:</p>
            <ul className="pl-10">
              <li>
                &bull; Choose “No Documentation Available” or “Upload Later”
              </li>
              <li>
                &bull; You can update the status when documents become available
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Using assets in transactions",
        content: (
          <div>
            <p>Assets play a critical role in financial transactions:</p>
            <ul className="pl-10">
              <li>
                &bull; Link fuel receipts, mortgage payments, and other costs to
                specific assets
              </li>
              <li>&bull; Track spending and usage for each asset accurately</li>
              <li>
                &bull; Maintain complete and organised records to support better
                tax deductions and financial management
              </li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "Mileage for Driving Instructors",
    businessTypes: ["driving_instructor"],
    videoLink: "https://vimeo.com/1100633214",
    items: [
      {
        title: "Why should I enter mileage?",
        content: (
          <div>
            <p>
              As a Driving Instructor, recording mileage is optional but can be
              beneficial. It enables you to:
            </p>
            <ul className="pl-10">
              <li>
                &bull; Track driving activity: Gain insights into how much you
                drive for work and privately.
              </li>
              <li>
                &bull; Calculate private use percentage: This helps
                differentiate business and personal vehicle use.
              </li>
              <li>
                &bull; Maintain accurate records: Detailed logs assist in future
                financial analysis.
              </li>
            </ul>
            <p>
              Although not mandatory, mileage records provide clarity on your
              vehicle’s business and private usage, supporting informed
              financial and tax decisions.
            </p>
          </div>
        ),
      },
      {
        title: "What if I skip logging mileage for a month?",
        content: (
          <div>
            <p>If you miss a month:</p>
            <ul className="pl-10">
              <li>
                &bull; Your total and private use percentages may be less
                accurate
              </li>
              <li>&bull; Reports might be incomplete</li>
              <li>
                &bull; You can backfill mileage data later—provided it’s within
                a single reporting period (entries spanning multiple periods are
                not allowed)
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Where is mileage data used?",
        content: (
          <div>
            <p>Mileage data supports:</p>
            <ul className="pl-10">
              <li>
                &bull; Calculating total miles driven (business and private)
              </li>
              <li>
                &bull; Determining private use percentage for tax and internal
                records
              </li>
              <li>&bull; Tracking vehicle usage across all your assets</li>
            </ul>
            <p>
              <strong>Important:</strong> For Driving Instructors, mileage
              tracking supplements your motor expenses—ensure you choose the
              correct vehicle as each entry applies to its original asset setup.
            </p>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1100633214" target="_blank">
                "How to Log Mileage as a Driving Instructor"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Mileage for Other Business Types",
    businessTypes: ["other"],
    videoLink: "https://vimeo.com/1100633246",
    items: [
      {
        title: "Why should I enter mileage?",
        content: (
          <div>
            <p>
              For businesses other than Driving Instructors, you must choose one
              method: either claim mileage or log motor expenses. You cannot do
              both for the same asset.
            </p>
            <p>If you choose to claim mileage:</p>
            <ul className="pl-10">
              <li>
                &bull; It’s essential for calculating tax reimbursement using
                HMRC mileage rates
              </li>
              <li>
                &bull; It streamlines expense reporting—no need to log
                individual vehicle costs
              </li>
              <li>
                &bull; It ensures you have compliant and organised business
                records
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "What if I skip a month of data?",
        content: (
          <div>
            <p>If a month is missed:</p>
            <ul className="pl-10">
              <li>
                &bull; The mileage won’t count towards your annual mileage total
              </li>
              <li>&bull; Your tax reimbursement will be lower</li>
              <li>&bull; Reporting will be less accurate</li>
            </ul>
            <p>
              You can add entries later, as long as they fall within a single
              reporting period
            </p>
          </div>
        ),
      },
      {
        title: "Where is mileage data used?",
        content: (
          <div>
            <p>
              Mileage data for Other Business Types calculates your tax
              reimbursement:
            </p>
            <ul className="pl-10">
              <li>&bull; £0.45 per mile for the first 10,000 miles</li>
              <li>&bull; £0.25 per mile after 10,000 miles</li>
            </ul>
            <p>The data:</p>
            <ul className="pl-10">
              <li>&bull; Feeds into tax return summaries</li>
              <li>
                &bull; Resets automatically each tax year for easy tracking
              </li>
            </ul>
            <p>
              <strong>Important:</strong> If you claim mileage, you cannot also
              log motor expenses for that asset. This choice is permanent unless
              changed by an administrator.
            </p>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1100633246" target="_blank">
                "How to Log Mileage as Other Business Type"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Mileage for Landlord Business Type",
    businessTypes: ["landlord"],
    videoLink: "https://vimeo.com/1119105139",
    items: [
      {
        title: "Why should I enter mileage?",
        content: (
          <div>
            <p>
              For businesses other than Driving Instructors, you must choose one
              method: either claim mileage or log motor expenses. You cannot do
              both for the same asset.
            </p>
            <p>If you choose to claim mileage:</p>
            <ul className="pl-10">
              <li>
                &bull; It’s essential for calculating tax reimbursement using
                HMRC mileage rates
              </li>
              <li>
                &bull; It streamlines expense reporting—no need to log
                individual vehicle costs
              </li>
              <li>
                &bull; It ensures you have compliant and organised business
                records
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "What if I skip a month of data?",
        content: (
          <div>
            <p>If a month is missed:</p>
            <ul className="pl-10">
              <li>
                &bull; The mileage won’t count towards your annual mileage total
              </li>
              <li>&bull; Your tax reimbursement will be lower</li>
              <li>&bull; Reporting will be less accurate</li>
            </ul>
            <p>
              You can add entries later, as long as they fall within a single
              reporting period
            </p>
          </div>
        ),
      },
      {
        title: "Where is mileage data used?",
        content: (
          <div>
            <p>
              Mileage data for a Landlord calculates your tax reimbursement:
            </p>
            <ul className="pl-10">
              <li>&bull; £0.45 per mile for the first 10,000 miles</li>
              <li>&bull; £0.25 per mile after 10,000 miles</li>
            </ul>
            <p>The data:</p>
            <ul className="pl-10">
              <li>&bull; Feeds into tax return summaries</li>
              <li>
                &bull; Resets automatically each tax year for easy tracking
              </li>
            </ul>
            <p>
              <strong>Important:</strong> If you claim mileage, you cannot also
              log motor expenses for that asset. This choice is permanent unless
              changed by an administrator.
            </p>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1119105139" target="_blank">
                "How to Log Mileage as a Landlord Business Type"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Offboarding",
    items: [
      {
        title: "Leave FBTC",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you wish to leave FBTC, then you will need to reach
                out to the FBTC team.
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You can do this by using our Leave FBTC feature, by
                  getting into ‘My Profile’, ‘Leave FBTC’.
                </li>
                <li>
                  &bull; You need to leave a reason why you want to leave and
                  send this request to us.
                </li>
                <ul className="pl-10">
                  <li>&bull; Or you can call us on 0344 984 2515.</li>
                </ul>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547014/0228cbc86a" target="_blank">
                "Request to Leave FBTC"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Contact",
    items: [
      {
        title: "Report a problem",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you need to Report a Problem, you can do this by using
                our Report a Problem feature that can be accessible from either
                Dashboard, Transaction page or Submission page
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You need to click on an icon at the bottom right corner
                  of a page: ‘Report a Problem’.
                </li>
                <li>
                  &bull; You need to enter your phone number describe the
                  problem and submit the Form.
                </li>
                <ul className="pl-10">
                  <li>&bull; Or you can call us on 0344 984 2515.</li>
                </ul>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547025/12c13110ed" target="_blank">
                "Report a problem"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Request a call",
        content: (
          <div>
            <ul>
              <li>
                &bull; If you need to Request a Call, you can do this by using
                our Request a Call feature that can be accessible from either
                the Dashboard, Transaction page or Submission page.
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You need to click on an icon at the bottom right corner
                  of a page: ‘Request a Call’.
                </li>
                <li>
                  &bull; You need to enter your phone number, leave a message
                  and submit the Form.
                </li>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077543193/96766fa26f" target="_blank">
                "Request a call"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Dashboard",
    items: [
      {
        title: "Use the dashboard",
        content: (
          <div>
            <ul>
              <li>
                &bull; The dashboard shows total Income and Expenses per
                Business and Period. You can check the summary of Income and
                Expenses for each Category reported during the Period.
              </li>
              <ul className="pl-10">
                <li>
                  &bull; You can select which business data is displayed for,
                  you can also select a date range for that data, if you wish.
                </li>
              </ul>
              <li>
                &bull; Below the category tiles on the dashboard, you can also
                see a list of your recent transactions.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547136/1935b733a9" target="_blank">
                "Using the Dashboard"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Transactions",
    items: [
      {
        title: "Add a transaction",
        content: (
          <div>
            <ul>
              <li>&bull; Login to platform</li>
              <li>&bull; Click on "Add Transaction" on the main menu</li>
              <ul className="pl-10">
                <li>&bull; Business Field:</li>
                <ul className="pl-10">
                  <li>
                    &bull; Your default Business will be pre-selected. However,
                    you can change it to be able to enter Transaction for
                    another Business.
                  </li>
                </ul>
                <li>&bull; Category:</li>
                <ul className="pl-10">
                  <li>
                    &bull; You can either use search in Category modal and
                    search by Subcategory or Category
                  </li>
                  <li>
                    &bull; Or you can simply scroll and look for the needed
                    Category and Subcategory inside the Category modal
                  </li>
                </ul>
                <li>&bull; Date:</li>
                <ul className="pl-10">
                  <li>
                    &bull; The date is always pre-set as today’s date, you can
                    change it by clicking on a date field or calendar icon
                  </li>
                </ul>
                <li>&bull; Period label:</li>
                <ul className="pl-10">
                  <li>
                    &bull; Updates based on the selected Transaction date. This
                    will always show the reporting Period that the Transaction
                    falls in.
                  </li>
                </ul>
                <li>&bull; Amount</li>
                <li>&bull; Description:</li>
                <ul className="pl-10">
                  <li>
                    &bull; This field allows you to add text to identify a
                    transaction. This field is required for the Transactions
                    with the subcategory "Other".
                  </li>
                </ul>
                <li>&bull; Transaction Receipts:</li>
                <ul className="pl-10">
                  <li>
                    &bull; You can upload your Transaction Receipt by clicking
                    "Browse"
                  </li>
                  <li>
                    &bull; You can upload more than one attachment per
                    Transaction
                  </li>
                </ul>
              </ul>
              <li>&bull; Saving Transaction</li>
              <ul className="pl-10">
                <li>
                  &bull; You can either click "Save Transaction" - this will
                  save and close the page
                </li>
                <li>
                  &bull; Or you can click "Save and Add Another" - this will
                  save and open a new "Add Transaction" page
                </li>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547084/6b00c344f7" target="_blank">
                "Add a transaction"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Edit a transaction",
        content: (
          <div>
            <ul>
              <li>&bull; To edit a Transaction:</li>
              <ul className="pl-10">
                <li>&bull; Select the Transaction you want to edit</li>
                <li>&bull; Transaction detail page will open</li>
                <li>&bull; Click "Edit Transaction"</li>
              </ul>
              <li>&bull; Edit Transaction page will open:</li>
              <ul className="pl-10">
                <li>&bull; You can edit each field</li>
                <li>&bull; Add/remove Transaction receipt</li>
                <li>&bull; Update the Transaction by clicking on "Update"</li>
              </ul>
              <li>&bull; Or "Save and Add Another" Transaction</li>
              <li>&bull; Or "Cancel" the changes</li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547111/a6f7cbc1a2" target="_blank">
                "Edit a transaction"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "View my transactions",
        content: (
          <div>
            <ul>
              <li>&bull; Login to platform</li>
              <ul className="pl-10">
                <li>&bull; Select Transactions on the main navigation bar</li>
              </ul>
              <li>
                &bull; The Transaction list consists of the following
                information:
              </li>
              <ul className="pl-10">
                <li>&bull; Date – Transaction date</li>
                <li>&bull; Type</li>
                <li>&bull; Income</li>
                <li>&bull; Expense</li>
                <li>&bull; And / Or Refund</li>
                <li>&bull; Category/Subcategory</li>
                <li>&bull; Period</li>
                <li>&bull; Attachments – number of files attached</li>
                <li>&bull; Status – Transaction Status</li>
                <ul className="pl-10">
                  <li>&bull; Open</li>
                  <li>&bull; Re-Open</li>
                  <li>&bull; Submitted</li>
                  <li>&bull; Closed</li>
                </ul>
                <li>&bull; Description</li>
                <li>&bull; Amount</li>
              </ul>
              <li>&bull; Transactions are sorted by recently added</li>
              <li>
                &bull; Also, a list of recent Transactions can be accessed from
                the Dashboard page
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077552310/d3ade34640" target="_blank">
                "Viewing Transactions"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Find a transaction",
        content: (
          <div>
            <ul>
              <li>
                &bull; You can use filters or search features to find a specific
                Transaction
              </li>
              <li>
                &bull; You can search for transactions by transaction amount or
                description
              </li>
              <li>
                &bull; You can find a Transaction by filtering them when on
                Transaction page
              </li>
              <li>&bull; You can filter Transactions by:</li>
              <ul className="pl-10">
                <li>&bull; Date</li>
                <li>&bull; Period</li>
                <li>&bull; Type</li>
                <li>&bull; Category</li>
                <li>&bull; Subcategory</li>
                <li>&bull; Status</li>
                <ul className="pl-10">
                  <li>&bull; Open - can be edited</li>
                  <li>&bull; Closed - can’t be edited</li>
                </ul>
                <li>&bull; Attachments</li>
                <li>&bull; Refund</li>
              </ul>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077547102/b87af1484c" target="_blank">
                "Find a transaction"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Search",
    items: [
      {
        title: "What can I search for, and how can I search?",
        content: (
          <div>
            <ul>
              <li>&bull; You can search for a Transaction by:</li>
              <li>&bull; Transaction Description</li>
              <li>&bull; Any word in the description</li>
              <li>&bull; Amount</li>
              <li>&bull; A specific Transaction Amount</li>
              <li>&bull; Search is available from any page in the system</li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "Refunds",
    items: [
      {
        title: "Add a Refund",
        content: (
          <div>
            <ul>
              <li>&bull; The system gives the ability to enter Refund</li>
              <li>
                &bull; Either create a refund that is not linked to any
                Transaction
              </li>
              <li>&bull; Or add a Refund to the existing Transaction</li>
              <li>
                <br />
              </li>
              <li>
                &bull; To create a{" "}
                <strong>Refund that is not linked to any Transaction</strong>
              </li>
              <ul className="pl-10">
                <li>
                  &bull; Add a refund by selecting the "Add Refund" option on
                  the main navigation bar
                </li>
                <li>
                  &bull; This will open the "Transaction Refund" page that will
                  allow you to enter the details for the refund you wish to add.
                </li>
                <ul className="pl-10">
                  <li>&bull; Business Field:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Your default Business will be pre-selected.
                      However, you can change it to be able to enter a refund
                      for another Business.
                    </li>
                  </ul>
                  <li>&bull; Category:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; You can either use search in Category modal and
                      search by Subcategory or Category
                    </li>
                    <li>
                      &bull; Or you can simply scroll and look for the needed
                      Category and Subcategory inside the Category modal
                    </li>
                  </ul>
                  <li>&bull; Date:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; The date is always pre-set as today’s date, you can
                      change it by clicking on a date field or calendar icon
                    </li>
                  </ul>
                  <li>&bull; Period label:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Updates based on the selected refund date. This
                      will always show the reporting Period that the refund
                      falls in.
                    </li>
                  </ul>
                  <li>&bull; Amount</li>
                  <li>&bull; Description:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; This field allows you to add text to identify the
                      refund. This field is required for any refunds with the
                      subcategory "Other".
                    </li>
                  </ul>
                  <li>&bull; Transaction Receipts:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; You can upload your Transaction Receipt by clicking
                      "Browse"
                    </li>
                    <li>
                      &bull; You can upload more than one attachment per
                      Transaction
                    </li>
                  </ul>
                  <li>&bull; Saving Refund</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Click "Save Refund" - this will save and close the
                      page.
                    </li>
                    <li>
                      &bull; You will be able to identify your refund by a
                      Refund label on the Transaction page
                    </li>
                  </ul>
                </ul>
                <li>
                  <p>
                    Watch the video{" "}
                    <a
                      href="https://vimeo.com/1077552222/3034794170"
                      target="_blank"
                    >
                      "Add a Refund"
                    </a>
                  </p>
                </li>
              </ul>
              <li>
                <br />
              </li>
              <li>
                &bull; To create a{" "}
                <strong>
                  Refund that is linked to the existing Transaction
                </strong>
              </li>
              <ul className="pl-10">
                <li>
                  &bull; Search for the Transaction in which you received a
                  Refund.
                </li>
                <li>
                  &bull; Add a refund by selecting the "Add Refund" option on
                  the Transaction detail page
                </li>
                <li>
                  &bull; This will open the "Transaction Refund" page that will
                  allow you to enter the details for the refund you wish to add.
                </li>
                <ul className="pl-10">
                  <li>&bull; Business Field:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Your default Business will be pre-selected.
                      However, you can change it to be able to enter a refund
                      for another Business.
                    </li>
                  </ul>
                  <li>&bull; Category:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; You can either use search in Category modal and
                      search by Subcategory or Category
                    </li>
                    <li>
                      &bull; Or you can simply scroll and look for the needed
                      Category and Subcategory inside the Category modal
                    </li>
                  </ul>
                  <li>&bull; Date:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; The date is always pre-set as today’s date, you can
                      change it by clicking on a date field or calendar icon
                    </li>
                  </ul>
                  <li>&bull; Period label:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Updates based on the selected refund date. This
                      will always show the reporting Period that the refund
                      falls in.
                    </li>
                  </ul>
                  <li>&bull; Amount</li>
                  <li>&bull; Description:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; This field allows you to add text to identify the
                      refund. This field is required for any refunds with the
                      subcategory "Other".
                    </li>
                  </ul>
                  <li>&bull; Transaction Receipts:</li>
                  <ul className="pl-10">
                    <li>
                      &bull; You can upload your Transaction Receipt by clicking
                      "Browse"
                    </li>
                    <li>
                      &bull; You can upload more than one attachment per
                      Transaction
                    </li>
                  </ul>
                  <li>&bull; Saving Refund</li>
                  <ul className="pl-10">
                    <li>
                      &bull; Click "Save Refund" - this will save and close the
                      page.
                    </li>
                    <li>
                      &bull; You will be able to identify your refund by a
                      Refund label on the Transaction page
                    </li>
                  </ul>
                </ul>
                <li>
                  <p>
                    Watch the video{" "}
                    <a
                      href="https://vimeo.com/1077552287/3a24464ebe"
                      target="_blank"
                    >
                      "Add a linked Refund"
                    </a>
                  </p>
                </li>
              </ul>
              <li>
                <br />
              </li>
              <li>
                &bull; <strong>Note -</strong> Refund should always be added
                with the date you received it regardless of the original
                Transaction date/period
              </li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "Submissions",
    items: [
      {
        title: "Find my submissions",
        content: (
          <div>
            <ul>
              <li>&bull; Login to platform</li>
              <li>&bull; Select Submissions on the main navigation bar</li>
              <li>
                &bull; The Submissions page contains a list of all of your
                recent submissions, and consists of the following information:
              </li>
              <ul className="pl-10">
                <li>&bull; The period the submission was for</li>
                <li>&bull; The business the submission was for</li>
                <li>&bull; The status of the submission</li>
                <li>
                  &bull; Any comments that you added before submitting your
                  submission
                </li>
                <li>&bull; Income and expense total</li>
                <li>&bull; Profit/Loss calculation</li>
              </ul>
              <li>
                &bull; You can also click into each individual submission to see
                further details, view the transactions within the submission,
                and submit the data over to your accountant for review.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077557530/e472a6b726" target="_blank">
                "Finding Submission"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Submit a submission to my accountant",
        content: (
          <div>
            <ul>
              <li>&bull; Login to platform</li>
              <li>&bull; Select submissions on the main navigation bar</li>
              <li>
                &bull; Select the submission you wish to submit (check the
                business and period and click the line with the correct
                information)
              </li>
              <li>&bull; Click "Submit this data" button in the top right.</li>
              <li>
                &bull; You will then have any opportunity to add any notes you
                wish for your accountant to see and confirm that the data is
                complete and accurate.
              </li>
              <li>
                &bull; Once submitted, your submission will be sent to your
                accountant for review.
              </li>
            </ul>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1077543220/b468c52295" target="_blank">
                "Submit a Submission"
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "Private Use",
    businessTypes: ["driving_instructor", "other"],
    videoLink: "https://vimeo.com/1172619070",
    items: [
      {
        title: "What is Private Use?",
        content: (
          <div>
            <p>
              Private Use means using business goods or services for personal
              purposes. Tax rules require this to be declared so your accounts
              and tax return are correct.
            </p>
            <br />
            <p>
              Watch the video{" "}
              <a href="https://vimeo.com/1172619070" target="_blank">
                "Add a Private Use"
              </a>
            </p>
          </div>
        ),
      },
      {
        title: "Why Do I Need to Provide Figures?",
        content: (
          <div>
            <ul>
              <li>
                &bull; <strong>Stay Compliant:</strong> HMRC needs accurate
                business vs. personal use.
              </li>
              <li>
                &bull; <strong>Avoid Penalties:</strong> Wrong figures can lead
                to extra tax or fines.
              </li>
              <li>
                &bull; <strong>Keep Accounts Accurate:</strong> Shows the real
                cost of running your business.
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "Examples of Private Use:",
        content: (
          <div>
            <ul>
              <li>
                &bull; <strong>Driving Instructors:</strong> Using your lesson
                car for family trips, personal fuel.
              </li>
              <li>
                &bull; <strong>Other Business Types:</strong> Using materials or
                tools for your home projects.
              </li>
            </ul>
          </div>
        ),
      },
      {
        title: "What Happens if I Don’t Enter It?",
        content: (
          <div>
            <p>
              Your tax return may be incorrect, which could mean{" "}
              <strong>extra tax, penalties, or an audit.</strong>
            </p>
          </div>
        ),
      },
      {
        title: "How to Work It Out?",
        content: (
          <div>
            <ul>
              <li>&bull; Keep a simple note of personal use.</li>
              <li>
                &bull; Estimate a fair % if it’s mixed use (e.g., 15–20% for
                your car or phone).
              </li>
            </ul>
          </div>
        ),
      },
    ],
  },
  {
    category: "FAQ",
    items: [
      {
        title: "What is a default business?",
        content: (
          <div>
            <p>
              The default business is the one you choose to work with most of
              the time. It is set as default for your convenience. However, each
              page has a business filter, so you can always view data from your
              other businesses, create transactions, or submit a submission. You
              can also change your default business anytime in your profile
              settings.
            </p>
          </div>
        ),
      },
      {
        title: "What is my dashboard for?",
        content: (
          <div>
            <p>
              The dashboard displays income and expense totals per business and
              open period. You can also view a summary of income and expenses by
              category.
            </p>
          </div>
        ),
      },
      {
        title: "What do the statuses mean for transactions?",
        content: (
          <div>
            <p>
              Transaction Statuses reflect the current state of a transaction
              throughout its lifecycle. When a transaction is first created and
              has not yet been submitted, it is marked with the "Open" status.
              Once the submission data has been sent to your accountant, all
              transaction statuses change to "Submitted". During the submission
              review process, some transactions may be "Re-Opened" - this
              typically happens if the accountant identifies an issue and would
              like you to review and correct a transaction’s details. A
              transaction reaches the "Closed" status once it has been
              successfully reviewed and finalised by the accountant.
            </p>
          </div>
        ),
      },
      {
        title: "What do the submissions statuses mean?",
        content: (
          <div>
            <p>
              Submission Status indicates the current state of the submission
              data. When a submission is created but not yet submitted, it is
              marked as "Open". When a submission is open, you can continue to
              add transactions to that submission. Once the submission is sent
              to your accountant for review, the status changes to "In Review",
              and you cannot add any further transactions to the submission.
              During the review process, if the accountant identifies any
              issues, one or more transactions—and the submission itself—may be
              "Re-Opened" for corrections. Once all issues are resolved and the
              accountant completes the review, the submission status changes to
              "Closed".
            </p>
          </div>
        ),
      },
      {
        title: "How can I find a specific transaction?",
        content: (
          <div>
            <p>
              There are multiple ways to find an individual transaction - you
              can search for a transaction using the search bar, and typing in
              either the amount relating to the transaction, or keywords from
              the transaction description. If you would like to see all
              transactions with a shared characteristic, you can go into the
              transactions page and filter by date range, type, category or
              sub-category, or filter transactions based on their status, or
              whether they have an attachment or are classed as a refund.
            </p>
          </div>
        ),
      },
    ],
  },
  {
    category: "App",
    items: [
      {
        title: "Download our app to use FBTC on the go:",
        content: (
          <div>
            <p>
              <strong>Apple devices:</strong>
              <br />
              <a
                href="https://apps.apple.com/us/app/fbtc-accountancy-services/id6449941179"
                target="_blank"
              >
                https://apps.apple.com/us/app/fbtc-accountancy-services/id6449941179
              </a>
            </p>
            <br />
            <p>
              <strong>Android devices:</strong>
              <br />
              <a
                href="https://play.google.com/store/apps/details?id=com.fbtc"
                target="_blank"
              >
                https://play.google.com/store/apps/details?id=com.fbtc
              </a>
            </p>
          </div>
        ),
      },
    ],
  },
];
